import { SerializableObject } from '../../common-react/core';

import { Currency } from '../other/currency.type';

export class CashOnDeliveryInfo extends SerializableObject {
  public amount: number;
  public currency: Currency;
  /**
   * Bank identification number (4 digits) for the Account.
   */
  public accountBank: string;
  /**
   * Account Type identification number (2 digits). Icelanders call this "Höfuðbók".
   */
  public accountType: string;
  /**
   * Account number (6 digits).
   */
  public accountNumber: string;
  /**
   * National Identification Number of the Account Owner.
   */
  public accountIdentificationNumber: string;
  /**
   * A number referencing the Payment Slip, e.g. the invoice number. The Payment transaction will contain this number.
   */
  public slipNumber?: number;
  /**
   * Contains any reference text that the sender would like to include for the CashOnDelivery.
   */
  public reference?: string;
}
